module.exports = __webpack_public_path__ + "img/logo.d642ea4e.png";